import { DependencyList, EffectCallback, useEffect, useRef } from "react";

/**
 * O useEffect dispara tambem na montagem: efeitos que reagem a mudanca de estado
 * (como o refetch disparado pelo setSkipQuery) acabavam rodando ao abrir a tela.
 */
export const useEfeitoAposMontagem = (efeito: EffectCallback, deps: DependencyList) => {
  const montado = useRef(false);

  useEffect(() => {
    if (!montado.current) {
      montado.current = true;
      return undefined;
    }
    return efeito();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
